import { BaseService } from '@/core/base-service';
import { ITenant } from '@/admin/tenant-management/tenant.model';

export default class TenantMasterService extends BaseService<ITenant> {
  public constructor() {
    super('api/master/tenant');
  }
}
